// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sb-c";
export var backButton = "_sb-4";
export var backIcon = "_sb-5";
export var chevronShortcut = "_sb-6";
export var container = "_sb-1";
export var editor = "_sb-8";
export var editorWrapper = "_sb-7";
export var prefix = "_sb-2";
export var searchIcon = "_sb-3";
export var suffix = "_sb-9";
export var suffixContent = "_sb-a";
export var suffixText = "_sb-b";
export var wrapper = "_sb-0";